"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.investor = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var classnames_1 = require("classnames");
var Pages_1 = require("@/rendering/common/Pages");
var InvestorAction_1 = require("@/pages/investor/actions/InvestorAction");
var InvestorFormComponent_1 = require("@/pages/investor/components/InvestorFormComponent");
var AboutPage_1 = require("@/pages/common/components/AboutPage");
var core_1 = require("@material-ui/core");
var mapStateToProps = function (state) { return (__assign(__assign({}, state.investor), { menu: state.layout.menulist.filter(function (it) { return it.page === Pages_1.Pages.ABOUT; })[0] })); };
var mapDispatchToProps = function (dispatch) { return ({
    onInvestorSubmit: function (enquiry) { return dispatch(InvestorAction_1.default.onInvestorSubmit(enquiry)); },
}); };
exports.investor = function (props) {
    var headStyle = {
        backgroundImage: "url(" + props.backgroundImage + ")",
        backgroundSize: 'center 23%',
        backgroundAttachment: 'unset',
    };
    var renderP = function (it, i) { return (React.createElement("div", { key: i, className: "c-ssection__p" }, it.text)); };
    var renderImg = function (it, i) { return (React.createElement("img", { key: i, src: it })); };
    var renderSection = function (section, i, props) {
        var blockClass = classnames_1.default([
            'c-ssection__block',
            {
                'c-ssection__block--rev': !section.imageRight,
            },
        ]);
        return (React.createElement("div", { key: i, className: blockClass },
            React.createElement("div", { className: "c-ssection__main" }, section.paragraphs.map(function (it, j) { return renderP(it, j); })),
            React.createElement("div", { className: "c-ssection__side" }, section.images.map(function (it, j) { return renderImg(it, j); }))));
    };
    var formStyle = {
        backgroundImage: 'url(/res/img/formbg.jpg)',
        paddingTop: '50px',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
    };
    var formClass = 'c-ssection__block c-ssection__block--noflex l-container__mfull';
    var ui = {
        isLoading: props.isLoading,
        salutations: props.salutations,
    };
    var currentPage = Pages_1.Pages.INVESTOR;
    return (React.createElement(AboutPage_1.default, { title: props.title, headStyle: headStyle, currentPage: currentPage, menu: props.menu },
        React.createElement("div", { className: "c-ssection c-ssection--simple" },
            React.createElement(core_1.Hidden, { xsDown: true },
                React.createElement("div", { style: { height: 50 } })),
            props.sections.map(function (it, i) { return renderSection(it, i, props); }),
            React.createElement("div", { className: formClass, style: formStyle },
                React.createElement("div", { className: "c-page-header c-page-header--center c-page-header--center-mobile" },
                    React.createElement("div", { className: "c-page-header__body" },
                        React.createElement("h2", { className: "c-page-header__title" }, props.t.investorFormTitle),
                        React.createElement("div", { className: "c-page-header__caption" }, props.t.investorFormCaption))),
                React.createElement(InvestorFormComponent_1.default, { form: props.enquiry, tForm: props.tForm, ui: ui, onFormSubmit: props.onInvestorSubmit }),
                React.createElement("div", { className: "c-npage__subcontent" },
                    React.createElement("span", { className: "fal fa-info-circle" }),
                    "\u00A0",
                    React.createElement("span", { dangerouslySetInnerHTML: { __html: props.t.privacyPolicy } }))))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.investor);
